import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { chatApi as n } from "@maat/api-chat";
//#region src/hooks/useMessageRequestsQuery.ts
var r = (r) => t({
	queryKey: e.messageRequests(),
	queryFn: () => n.getMessageRequests(),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as useMessageRequestsQuery };
